export enum ApiQueryOperator {
  like = '~',
  eq = '=',
  neq = '!=',
  lt = '<',
  lte = '<=',
  gt = '>',
  gte = '>=',
  in = ':',
  nin = '!:',
}

export interface IApiList<T> {
  data: T[];
  limit?: number;
  offset?: number;
  sort?: string[];
  total: number;
}

export interface IApiQueryParam {
  value: string | string[];
  operator: ApiQueryOperator;
  key: string;
}

export enum RequestStatus {
  UNINITIATED = 'uninitiated',
  PENDING = 'pending',
  SUCCESS = 'success',
  FAILED = 'failed',
}

export interface IRequestState {
  isLoading: boolean;
  status: RequestStatus;
  errors: IApiErrorPayloadWithCode;
}

export type ApiSuccessPayload = Record<string, any>;

export interface IApiErrorPayloadWithCode {
  errorMessages: string[];
  statusCode?: string;
  id?: string;
  code?: string;
}

export interface IApiAction {
  type: string;
  meta?: any;
  payload?: ApiSuccessPayload | IApiErrorPayloadWithCode | IApiActionPayload;
}

export interface IApiActionPayload {
  requestName: string;
}

export interface IApiError {
  param?: string;
  value?: string;
  statusCode?: string;
  msg: string;
  id?: string;
  code?: string;
  remainingAttempts?: number;
}
